import './IdleVsHpLegendRow.scss';

import React from 'react';
import { DqText } from '../dq-text';
import { useIntl } from 'react-intl';
import { msToTime } from '../../utils/logs/logHelpers';

export interface IdleVsHpLegendRowProps {
  legendHeading: string;
  dotColorClass: string;
  showTimeDetails: boolean;
  chartDataSize: number;
}

export const IdleVsHpLegendRow: React.FC<IdleVsHpLegendRowProps> = props => {
  const { legendHeading, dotColorClass, showTimeDetails, chartDataSize } = props;
  const { formatNumber } = useIntl();

  return (
    <div className="legend-row">
      <div className={`legend-row-heading ${dotColorClass}`}>
        <span className="legend-row-dot" />
        <DqText variant="body-strong">{legendHeading}</DqText>
      </div>
      {showTimeDetails ? (
        <div className="legend-row-time-info">
          <span className="legend-row-dot" /> {/* "invisible" dot so both rows of text are left-aligned. */}
          <DqText>{msToTime(chartDataSize, formatNumber).replaceAll(', ', ',\n')}</DqText>
        </div>
      ) : undefined}
    </div>
  );
};
